<template>
  <Marco>
    <div slot="content">
      <div />

      <div>
        <div class="main-title">
          <h1 class="title">{{ step.pregunta }}</h1>
        </div>

        <div class="wysiwyg">
          <div>
            <div>
              <div class="main-title">
                <h1 class="title">Presupuesto guardado</h1>
              </div>

              <div class="wysiwyg">
                <p>Tu presupuesto ha sido guardado</p>
                <p class="text-type1">
                  Este es el número de referencia: {{ step.mensaje }}
                </p>
                <p>
                  Es importante que lo guardes ya que te servirá para
                  informarnos de la cotización que acabas de realizar.
                </p>
                <p v-if="step.resumen.tomador.email">
                  También te hemos enviado el presupuesto por email a la
                  dirección que nos has indicado.
                </p>
                <p v-else>
                  También te hemos enviado un SMS al móvil que nos has indicado
                  con el enlace del presupuesto.
                </p>
                <span class="btnSalir">
                  <a href="#" style @click="goToMMTSeguros">Salir</a>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Marco>
</template>

<script>
export default {
  store: ["step"],

  methods: {
    goToMMTSeguros() {
      window.location = "http://www.mmtseguros.es";
    }
  }
};
</script>

<style lang="scss" scoped>
.btnSalir {
  font-size: 1.6em;
  float: left;
  text-decoration: none;
  font-weight: bolder;
  display: inline-block;
  vertical-align: middle;
  min-width: 8em;
  border-radius: 5px;
  background-color: #008cb4;
  font-size: 2rem;
  text-align: center;
}
.btnSalir a {
  display: block;
  text-decoration: none;
  padding: 1em;
  color: #ffffff;
}
</style>
